var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconMonitor = function SvgIconMonitor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 3.333H3.333a.833.833 0 00-.833.834V12.5c0 .46.373.833.833.833h13.334c.46 0 .833-.373.833-.833V4.167a.833.833 0 00-.833-.834zM5.833 16.667h8.334M7.5 13.333v3.334m5-3.334v3.334",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.667 10l2.5-2.5 1.666 1.667 2.5-2.5",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconMonitor;